<template>
  <h3 class="pb5">Rapport hebdomadaire des dossiers Espacejeux (CDX_0144)</h3>
  <CritereRechercheEspaceJeux :only-show-date="true" ref="critereRechercheEspaceJeux"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheEspaceJeux from "@/components/rapports/Rechercher/CritereRechercheEspaceJeux.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersHebdomadaireEspaceJeux",
  components: {CritereRechercheEspaceJeux, ButtonBar},
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("EspaceJeux");
    this.isRechercheDataLoading = true;
    this.$store.dispatch("dossier/obtenirSiteEntiteAction")
        .then((res) => {
          this.entiteDefault = res.data.entite;
          this.siteDefault = res.data.site;
          this.$store.dispatch("dossier/rechercherDefaut48HeuresAction")
              .then((res) => {
                this.assignerResultat(res);
                this.isRechercheDataLoading = false;
              });
        });
  },
  data() {
    return {
      isRechercheDataLoading: false,
      entiteDefault: null,
      siteDefault: null,
    }
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheEspaceJeux.getCriteresRecherche();
      criteresRecherche.titre = "DossiersHebdomadaireEspaceJeux";
      criteresRecherche.nomRapport = "espaceJeux.HebdomadaireEspacejeuxDossierGenerateurRapport_CDX_0144";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    },
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheEspaceJeux.assignerListe(res.data.entiteDecision);
    },
  },
}
</script>
